module.exports = __webpack_public_path__ + "static/Service-staup-author4-cf11f542961cce28541b9f10d0b9ec5b.png";